<template>
  <UserLayout>
    <div
      class="ring-1 ring-gray-300 w-full rounded-lg"
      :class="LOADING ? 'bg-gray-medium' : 'bg-blue-lightest'"
    >
      <div class="md:hidden relative">
        <div :class="LOADING ? 'h-64' : 'h-64'">
          <img
            :src="require('@/assets/img/session-list-banner.jpg')"
            alt=""
            class="shadow ring-1 ring-gray-300 object-cover w-full rounded-lg h-64"
            @load="imgLoadHandler"
            v-show="!LOADING"
            @error="defaultBannerImage"
          />
        </div>
        <div
          class="flex items-center absolute top-0 right-0 bg-black bg-opacity-50 h-full rounded-lg"
        >
          <div class="md:px-32 px-16 space-y-4 md:space-x-2">
            <h3
              class="md:text-5xl text-xl leading-none capitalize font-semibold text-white"
            >
              Find <br />
              Classes
            </h3>
            <p class="md:text-lg text-sm text-white">
              Let's start the climb to the next step <br />
              Find a Class now!
            </p>
          </div>
        </div>
      </div>
      <div class="hidden md:flex">
        <div class="w-6/12 flex items-center">
          <div class="md:px-24 lg:px-32 space-y-4 space-x-2">
            <h3
              class="text-5xl leading-none capitalize font-semibold text-gray-dark"
            >
              Find <br />
              Classes
            </h3>
            <p class="text-lg">
              Let's start the climb to the next step <br />
              Find a Class now!
            </p>
          </div>
        </div>
        <div
          class="w-6/12 px-6 md:py-24 lg:py-4"
          :class="LOADING ? 'height-27' : 'height-27'"
        >
          <img
            :src="require('@/assets/img/session-list-banner.jpg')"
            alt=""
            class="shadow ring-1 ring-gray-300 object-cover w-full rounded-lg h-full"
            @load="imgLoadHandler"
            v-show="!LOADING"
            @error="defaultBannerImage"
          />
        </div>
      </div>
    </div>

    <div class="">
      <div class="flex-col flex-1">
        <div class="flex items-center justify-between mt-2">
          <div class="py-1">
            <div class="flex items-center md:py-4">
              <button
                type="button"
                class="inline-flex items-center h-8 px-2 text-sm transition-colors duration-150 ring-1 text-white rounded-md focus:outline-none bg-green-light hover:text-green-light hover:bg-white ring-green-light"
                @click="handleClickMenu"
              >
                <p class="text-sm px-1">Filters</p>
                <FilterIcon />
              </button>
              <!-- <div v-if="filterChipValues.length" class="flex items-center">
                <span class="text-3xl px-2 text-gray-dark font-leading">|</span>
                <div v-for="el in filterChipValues" :key="el.key" class="mr-2">
                  <FilterChip
                    class="w-max"
                    :data="el"
                    :handleClearFilterValue="handleClearFilterValue"
                  />
                </div>
                <button
                  type="button"
                  class="text-green-dark text-sm w-max p-1 flex rounded-lg"
                  @click="handleResetFilterValues"
                >
                  Clear Filters
                </button>
              </div> -->
            </div>
          </div>
        </div>

        <div class="space-y-10 mb-10">
          <!-- Category section -->
          <section
            v-if="!filterChipValues.length &&
            !filterApplied &&
            !topSessionListLoader"
          >
            <div class="flex justify-between items-center mb-6">
              <h6 class="md:text-3xl text-xl font-semibold leading-normal mt-0 text-blacklight">
                Top Classes
              </h6>
              <button
                type="button"
                class="inline-flex items-center h-8 px-1 text-sm transition-colors duration-150 ring-1 text-white rounded-md focus:outline-none bg-green-light hover:text-green-light hover:bg-white ring-green-light"
                @click="handleFilterChange('category', {value: 'all'})"
                v-if="
                  topSessionList &&
                  topSessionList.data &&
                  topSessionList.data.length > 4
                "
              >
                <span class="px-1 whitespace-nowrap">See all</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M13 7l5 5m0 0l-5 5m5-5H6"
                  />
                </svg>
              </button>
            </div>
            <div>
              <!-- class="carouselContainer" -->
              <div
                v-if="
                  topSessionList &&
                  topSessionList.data &&
                  topSessionList.data.length
                "
              >
                <Carousel class="">
                  <div v-for="d in topSessionList.data" :key="d.id">
                    <router-link
                      v-if="d.entity_type==1"
                      :to="{
                        name: 'UserSessionDetails',
                        params: { id: d.id },
                      }"
                    >
                      <!-- <SessionCard :data="d" /> -->
                      <Card :data="d"/>
                    </router-link>
                    <router-link
                      v-if="d.entity_type==2"
                      :to="{
                        name: 'UserCourseDetails',
                        params: { id: d.id },
                      }"
                    >
                      <!-- <SessionCard :data="d" /> -->
                      <Card :data="d"/>
                    </router-link>
                  </div>
                </Carousel>
              </div>
              <div
                class="ml-2"
                v-if="topSessionList && topSessionList.statusCode == 404"
              >
                No data found.
              </div>
            </div>
          </section>
          <ContentLoader v-else-if="!filterApplied" :size="4" :type="'session'"></ContentLoader>
          <!-- Language section -->
          <section
            v-if="
              !filterChipValues.length &&
              !filterApplied &&
              !categorySessionListLoader
            "
          >
            <div class="flex justify-between items-center mb-6">
              <h6 class="md:text-3xl text-xl font-semibold leading-normal mt-0 text-blacklight">
                Yoga Category Classes
              </h6>
              <button
                type="button"
                class="inline-flex items-center h-8 px-1 text-sm transition-colors duration-150 ring-1 text-white rounded-md focus:outline-none bg-green-light hover:text-green-light hover:bg-white ring-green-light"
                @click="handleFilterChange('category', categoriesList[0].id)"
                v-if="
                  categorySessionList &&
                  categorySessionList.data &&
                  categorySessionList.data.length > 4
                "
              >
                <span class="px-1 whitespace-nowrap">See all</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M13 7l5 5m0 0l-5 5m5-5H6"
                  />
                </svg>
              </button>
            </div>
            <div>
              <!-- class="carouselContainer" -->
              <div
                v-if="
                  categorySessionList &&
                  categorySessionList.data &&
                  categorySessionList.data.length
                "
              >
                <Carousel class="">
                  <div v-for="d in categorySessionList.data" :key="d.id">
                     <router-link
                      v-if="d.entity_type==1"
                      :to="{
                        name: 'UserSessionDetails',
                        params: { id: d.id },
                      }"
                    >
                      <!-- <SessionCard :data="d" /> -->
                      <Card :data="d"/>
                    </router-link>
                    <router-link
                      v-if="d.entity_type==2"
                      :to="{
                        name: 'UserCourseDetails',
                        params: { id: d.id },
                      }"
                    >
                      <!-- <SessionCard :data="d" /> -->
                      <Card :data="d"/>
                    </router-link>
                  </div>
                </Carousel>
              </div>
              <div
                class="ml-2"
                v-if="
                  categorySessionList && categorySessionList.statusCode == 404
                "
              >
                No data found.
              </div>
            </div>
          </section>
          <ContentLoader v-else-if="!filterApplied" :size="4" :type="'session'"></ContentLoader>
          <!-- sub banner section -->
          <section v-if="!filterChipValues.length && !filterApplied">
            <div class="">
              <img
                src=""
                alt=""
                class="shadow ring-1 ring-gray-300 object-cover md:h-64 h-40 w-full rounded"
                @error="defaultBannerImage"
              />
            </div>
          </section>

          <!-- Private Session section -->
          <section class=""
            v-if="
              !filterChipValues.length &&
              !filterApplied &&
              !langSessionListLoader
            "
          >
            <div class="flex justify-between items-center mb-6">
              <h6 class="md:text-3xl text-xl font-semibold leading-normal mt-0 text-blacklight">
                English Language Classes
              </h6>
              <button
                type="button"
                class="inline-flex items-center h-8 px-1 text-sm transition-colors duration-150 ring-1 text-white rounded-md focus:outline-none bg-green-light hover:text-green-light hover:bg-white ring-green-light"
                @click="handleFilterChange('language', languages[0].value)"
                v-if="
                  languageSessionList &&
                  languageSessionList.data &&
                  languageSessionList.data.length > 4
                "
              >
                <span class="px-1 whitespace-nowrap">See all</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M13 7l5 5m0 0l-5 5m5-5H6"
                  />
                </svg>
              </button>
            </div>
            <div>
              <!-- class="carouselContainer" -->
              <div
                v-if="
                  languageSessionList &&
                  languageSessionList.data &&
                  languageSessionList.data.length
                "
              >
                <Carousel class="">
                  <div v-for="d in languageSessionList.data" :key="d.id">
                    <router-link
                      v-if="d.entity_type==1"
                      :to="{
                        name: 'UserSessionDetails',
                        params: { id: d.id },
                      }"
                    >
                      <!-- <SessionCard :data="d" /> -->
                      <Card :data="d"/>
                    </router-link>
                    <router-link
                      v-if="d.entity_type==2"
                      :to="{
                        name: 'UserCourseDetails',
                        params: { id: d.id },
                      }"
                    >
                      <!-- <SessionCard :data="d" /> -->
                      <Card :data="d"/>
                    </router-link>
                  </div>
                </Carousel>
              </div>
              <div
                class="ml-2"
                v-if="
                  languageSessionList && languageSessionList.statusCode == 404
                "
              >
                No data found.
              </div>
            </div>
          </section>
          <ContentLoader v-else-if="!filterApplied" :size="4" :type="'session'"></ContentLoader>
        </div>

        <div class="flex">
          <div class="w-full" v-if="filterChipValues.length || filterApplied">
            <!-- <SessionsFindCard
              :data="findSessionsListData"
              :statusCode="findSessionsList && findSessionsList.statusCode"
            /> -->
            <div class="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-y-3 gap-x-5"
              v-if="findSessionsListData && findSessionsListData.length"
            >
            <div v-for="d in findSessionsListData" :key="d.id">
                 <router-link
                      v-if="d.entity_type==1"
                      :to="{
                        name: 'UserSessionDetails',
                        params: { id: d.id },
                      }"
                    >
                      <Card :data="d"/>
                    </router-link>
                    <router-link
                      v-if="d.entity_type==2"
                      :to="{
                        name: 'UserCourseDetails',
                        params: { id: d.id },
                      }"
                    >
                      <Card :data="d"/>
                    </router-link>
              </div>
            </div>
            <div v-else class="justify-center pb-20">
              <div class="flex justify-center items-center">
                <img
                  :src="require(`../../../assets/img/findSessionsNoData.svg`)"
                  class="md:w-96 md:ml-0 ml-2 w-40 object-cover"
                />
              </div>
              <div class="text-center font-semibold mt-4 text-2xl tracking-wider">
                There are no results that match your search
              </div>
              <div class="mt-2 text-center text-gray-light font-medium">
                Please try adjusting your search keywords or filters
              </div>
            </div>
            <Pagination
              v-if="findSessionsListData.length"
              :currentPage="currentPage"
              :handlePageChange="handlePageChange"
              :totalPages="totalPages"
            />
          </div>
          <Modal
            :title="'Filters'"
            :headerClass="'text-xl pt-1'"
            v-model="isMenuOpen"
            :classStr="'max-w-lg'"
            class="modal"
            :whiteCross="'text-white text-4xl'"
          >
            <!-- <SideBarFilter
              @allFiltersApplied="setAllFilters"
              :isMenuOpen="isMenuOpen"
              :handleFilterChange="handleFilterChange"
              :handleResetFilterValues="handleResetFilterValues"
              :filterListing="[
                {
                  type: 'range',
                  label: 'Budget',
                  value: newFilterByValues.cost.value,
                  id: newFilterByValues.cost.id,
                  key: 'cost',
                  options: [
                    {
                      label: '$10', // $10 and below
                      value: { cost_min: empty_string, cost_max: 10 },
                      id: 1,
                    },
                    {
                      label: '$20', // $10-$20
                      value: { cost_min: 10, cost_max: 20 },
                      id: 2,
                    },
                    {
                      label: '$50', // $20-$50
                      value: { cost_min: 20, cost_max: 50 },
                      id: 3,
                    },
                    {
                      label: '$5000', // $50 and above
                      value: { cost_min: 50, cost_max: empty_string },
                      id: 4,
                    },
                  ],
                },
                {
                  type: 'button',
                  label: 'Category',
                  key: 'category',
                  value: newFilterByValues.category.value,
                  options: [...categories],
                },
                {
                  type: 'button',
                  label: 'Difficulty',
                  value: newFilterByValues.difficulty.value,
                  key: 'difficulty',
                  options: [...difficulties],
                },
                {
                  type: 'button',
                  label: 'Language',
                  value: newFilterByValues.language.value,
                  key: 'language',
                  options: [...languages],
                },
                {
                  type: 'button',
                  label: 'Type',
                  value: newFilterByValues.entity_type.value,
                  key: 'entity_type',
                  options: [
                    { label: 'Sessions Only', value: 1 },
                    { label: 'Courses Only', value: 2 },
                  ],
                },
              ]"
            /> -->

            <div class="overflow-auto" style="height: 70vh">
              <div class="flex justify-between">
                <p class="black mb-2 tracking-wider">Budget</p>
              </div>
              <label class="text-gray-light mb-4 text-sm">
                <!-- <input
                  type="range"
                  class="w-full max-w-md accent-pink-500 slider mb-5"
                  min="1"
                  max="4"
                  v-model="budget"
                /> -->
                <MultiRangeSlider
                  :min="0"
                  :max="150"
                  :ruler="false"
                  :label="false"
                  :minCaption="'' + budgetMinValue"
                  :maxCaption="'' + budgetMaxValue"
                  :baseClassName="'multi-range-slider max-w-md'"
                  :minValue="budgetMinValue"
                  :maxValue="budgetMaxValue"
                  @input="UpdateValues"
                />
                <div class="grid md:grid-cols-4 grid-cols-2 gap-4 mb-8">
                  <span class="ml-1">$0</span>
                  <span class="ml-5">$50</span>
                  <span class="ml-1"></span>
                  <span class="pl-12">$150+</span>
                </div>
              </label>

              <hr class="text-gray-400 mb-4" />

              <div class="flex justify-between">
                <p class="text-black mb-2 tracking-wider">Category</p>
              </div>
              <div
                class="grid md:grid-cols-3 grid-cols-2 gap-2 mb-4 p-1 max-w-md"
                :class="
                  showMoreCategory === false ? 'h-24 overflow-hidden' : ''
                "
              >
                <button
                  class="items-center h-10 text-white transition-colors duration-150 bg-green-light rounded-lg focus:outline-none ring-1 ring-gray-300 text-sm"
                  v-for="s in selectedCategories"
                  :key="s.id"
                  @click="onclickCategory(s)"
                >
                  <div class="flex justify-between px-2">
                    <span class="mr-2">{{ s.name }}</span>
                    <X />
                  </div>
                </button>
                <button
                  class="items-center h-10 text-gray-light transition-colors duration-150 bg-white rounded-lg focus:outline-none ring-1 ring-gray-300 text-sm"
                  v-for="c in categoriesList"
                  :key="c.id"
                  @click="onclickCategory(c)"
                >
                  <div class="flex justify-between px-2">
                    <span class="mr-2">{{ c.name }}</span>
                    <Plus />
                  </div>
                </button>
              </div>
              <button
                class="underline focus:outline-none italic text-sm pb-2"
                @click="showMoreCategory = !showMoreCategory"
              >
                Show {{ showMoreCategory ? "less" : "more" }}
              </button>
              <hr class="text-gray-400 mb-4" />

              <div class="flex justify-between">
                <p class="text-black mb-2 tracking-wider">Difficulty</p>
              </div>
              <div class="grid md:grid-cols-3 grid-cols-2 gap-4 mb-8 p-1">
                <button
                  class="items-center relative h-32 text-white transition-colors duration-150 bg-green-light rounded-lg focus:outline-none ring-1 ring-gray-300 text-sm flex-col"
                  v-for="s in difficultySelected"
                  :key="s.id"
                  @click="onclickDifficulty(s)"
                >
                  <div class="absolute right-0 p-1">
                    <X />
                  </div>
                  <svg
                    v-if="s.id == 1"
                    width="60"
                    height="70"
                    viewBox="0 0 65 65"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="mx-auto pt-4"
                  >
                    <path
                      d="M32.225 42.839c4.427 0 8-3.574 8-8 0-2.987-1.626-5.6-4-6.96L10.332 12.891l14.747 25.546c1.333 2.614 4.026 4.4 7.146 4.4zm0-34.667c-4.826 0-9.333 1.333-13.253 3.52l5.6 3.226c2.32-.906 4.987-1.413 7.653-1.413 11.787 0 21.334 9.547 21.334 21.334 0 5.893-2.374 11.226-6.24 15.066h-.027a2.655 2.655 0 0 0 0 3.76 2.713 2.713 0 0 0 3.787.027 26.585 26.585 0 0 0 7.813-18.853c0-14.667-12-26.667-26.667-26.667zM5.56 34.839c0 7.36 2.986 14.026 7.813 18.853a2.68 2.68 0 0 0 4.337-.89 2.656 2.656 0 0 0-.577-2.897 21.2 21.2 0 0 1-6.24-15.066c0-2.667.507-5.334 1.44-7.734l-3.227-5.6c-2.213 4-3.546 8.48-3.546 13.334z"
                      fill="#364B69"
                    />
                  </svg>
                  <svg
                    v-if="s.id == 2"
                    width="60"
                    height="70"
                    viewBox="0 0 65 65"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="mx-auto pt-4"
                  >
                    <path
                      d="m32.157 3.853-7.627 28.48a8.049 8.049 0 0 0 1.92 8.16 8.033 8.033 0 0 0 11.334 0 8.036 8.036 0 0 0 2.08-7.76M39.09 9.107l1.654 6.213A21.308 21.308 0 0 1 53.49 34.84c0 5.893-2.373 11.227-6.24 15.067h-.026a2.656 2.656 0 0 0 0 3.76 2.713 2.713 0 0 0 3.786.026 26.583 26.583 0 0 0 7.814-18.853c0-12.32-8.374-22.667-19.734-25.733zm-13.866.026C13.89 12.173 5.49 22.573 5.49 34.84c0 7.36 2.987 14.027 7.814 18.853a2.68 2.68 0 0 0 4.337-.889 2.656 2.656 0 0 0-.577-2.897 21.2 21.2 0 0 1-6.24-15.067c0-8.933 5.173-16.373 12.773-19.6"
                      fill="#364B69"
                    />
                  </svg>
                  <svg
                    v-if="s.id == 3"
                    width="60"
                    height="70"
                    viewBox="0 0 65 65"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="mx-auto pt-4"
                  >
                    <path
                      d="M32.09 42.84a8 8 0 0 1-8-8c0-2.987 1.626-5.6 4-6.96l25.893-14.987L39.236 38.44c-1.333 2.613-4.026 4.4-7.146 4.4zm0-34.667c4.826 0 9.333 1.334 13.253 3.52l-5.6 3.227c-2.32-.907-4.987-1.413-7.654-1.413A21.333 21.333 0 0 0 10.757 34.84c0 5.893 2.373 11.227 6.24 15.067h.027a2.656 2.656 0 0 1 0 3.76 2.713 2.713 0 0 1-3.787.026A26.583 26.583 0 0 1 5.423 34.84 26.667 26.667 0 0 1 32.089 8.173zM58.755 34.84c0 7.36-2.986 14.027-7.813 18.853a2.68 2.68 0 0 1-4.337-.889 2.656 2.656 0 0 1 .577-2.897 21.2 21.2 0 0 0 6.24-15.067c0-2.667-.507-5.333-1.44-7.733l3.227-5.6c2.213 4 3.546 8.48 3.546 13.333z"
                      fill="#364B69"
                    />
                  </svg>
                  <div class="flex justify-between px-2 py-2">
                    <span class="mr-2">{{ s.level }}</span>
                  </div>
                </button>
                <button
                  class="items-center h-32 relative text-gray-light transition-colors duration-150 bg-white rounded-lg focus:outline-none ring-1 ring-gray-300 text-sm flex-col"
                  v-for="d in difficultiesList"
                  :key="d.id"
                  @click="onclickDifficulty(d)"
                >
                  <div class="absolute right-0 p-1">
                    <Plus />
                  </div>
                  <svg
                    v-if="d.id == 1"
                    width="60"
                    height="70"
                    viewBox="0 0 65 65"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="mx-auto pt-4"
                  >
                    <path
                      d="M32.225 42.839c4.427 0 8-3.574 8-8 0-2.987-1.626-5.6-4-6.96L10.332 12.891l14.747 25.546c1.333 2.614 4.026 4.4 7.146 4.4zm0-34.667c-4.826 0-9.333 1.333-13.253 3.52l5.6 3.226c2.32-.906 4.987-1.413 7.653-1.413 11.787 0 21.334 9.547 21.334 21.334 0 5.893-2.374 11.226-6.24 15.066h-.027a2.655 2.655 0 0 0 0 3.76 2.713 2.713 0 0 0 3.787.027 26.585 26.585 0 0 0 7.813-18.853c0-14.667-12-26.667-26.667-26.667zM5.56 34.839c0 7.36 2.986 14.026 7.813 18.853a2.68 2.68 0 0 0 4.337-.89 2.656 2.656 0 0 0-.577-2.897 21.2 21.2 0 0 1-6.24-15.066c0-2.667.507-5.334 1.44-7.734l-3.227-5.6c-2.213 4-3.546 8.48-3.546 13.334z"
                      fill="#364B69"
                    />
                  </svg>
                  <svg
                    v-if="d.id == 2"
                    width="60"
                    height="70"
                    viewBox="0 0 65 65"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="mx-auto pt-4"
                  >
                    <path
                      d="m32.157 3.853-7.627 28.48a8.049 8.049 0 0 0 1.92 8.16 8.033 8.033 0 0 0 11.334 0 8.036 8.036 0 0 0 2.08-7.76M39.09 9.107l1.654 6.213A21.308 21.308 0 0 1 53.49 34.84c0 5.893-2.373 11.227-6.24 15.067h-.026a2.656 2.656 0 0 0 0 3.76 2.713 2.713 0 0 0 3.786.026 26.583 26.583 0 0 0 7.814-18.853c0-12.32-8.374-22.667-19.734-25.733zm-13.866.026C13.89 12.173 5.49 22.573 5.49 34.84c0 7.36 2.987 14.027 7.814 18.853a2.68 2.68 0 0 0 4.337-.889 2.656 2.656 0 0 0-.577-2.897 21.2 21.2 0 0 1-6.24-15.067c0-8.933 5.173-16.373 12.773-19.6"
                      fill="#364B69"
                    />
                  </svg>
                  <svg
                    v-if="d.id == 3"
                    width="60"
                    height="70"
                    viewBox="0 0 65 65"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="mx-auto pt-4"
                  >
                    <path
                      d="M32.09 42.84a8 8 0 0 1-8-8c0-2.987 1.626-5.6 4-6.96l25.893-14.987L39.236 38.44c-1.333 2.613-4.026 4.4-7.146 4.4zm0-34.667c4.826 0 9.333 1.334 13.253 3.52l-5.6 3.227c-2.32-.907-4.987-1.413-7.654-1.413A21.333 21.333 0 0 0 10.757 34.84c0 5.893 2.373 11.227 6.24 15.067h.027a2.656 2.656 0 0 1 0 3.76 2.713 2.713 0 0 1-3.787.026A26.583 26.583 0 0 1 5.423 34.84 26.667 26.667 0 0 1 32.089 8.173zM58.755 34.84c0 7.36-2.986 14.027-7.813 18.853a2.68 2.68 0 0 1-4.337-.889 2.656 2.656 0 0 1 .577-2.897 21.2 21.2 0 0 0 6.24-15.067c0-2.667-.507-5.333-1.44-7.733l3.227-5.6c2.213 4 3.546 8.48 3.546 13.333z"
                      fill="#364B69"
                    />
                  </svg>
                  <div class="flex justify-between px-2 py-2">
                    <span class="mr-2">{{ d.level }}</span>
                  </div>
                </button>
              </div>

              <hr class="text-gray-400 mb-4" />

              <div class="flex justify-between">
                <p class="text-black mb-2 tracking-wider">Language</p>
              </div>
              <div
                class="grid md:grid-cols-3 grid-cols-2 gap-4 mb-4 p-1 max-w-sm"
              >
                <button
                  class="items-center h-10 text-white transition-colors duration-150 bg-green-light rounded-lg focus:outline-none ring-1 ring-gray-300 text-sm"
                  v-for="s in selectedLanguages"
                  :key="s.id"
                  @click="onclickLanguage(s)"
                >
                  <div class="flex justify-between px-2">
                    <span class="mr-2">{{ s.language }}</span>
                  </div>
                </button>
                <button
                  class="items-center h-10 text-gray-light transition-colors duration-150 bg-white rounded-lg focus:outline-none ring-1 ring-gray-300 text-sm"
                  v-for="l in languagesList"
                  :key="l.id"
                  @click="onclickLanguage(l)"
                >
                  <div class="flex justify-between px-2">
                    <span class="mr-2">{{ l.language }}</span>
                    <Plus />
                  </div>
                </button>
              </div>

              <hr class="text-gray-400 mb-4" />

              <div class="flex justify-between">
                <p class="black mb-2 tracking-wider">Types</p>
              </div>
              <div class="grid md:grid-cols-4 grid-cols-2 gap-4 mb-10 px-1">
                <button
                  class="flex flex-col items-center h-24 px-5 text-gray-dark transition-colors duration-150 bg-white rounded-lg ring-1 ring-gray-300 focus:outline-none text-xs"
                  @click="typeSelected = ''"
                  :class="{
                    'bg-green-light text-yellow-100': typeSelected == '',
                  }"
                >
                  <svg
                    width="50"
                    height="65"
                    viewBox="0 0 65 65"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8.668 8.004v37.333h29.85v-2.666H11.335v-32h36v2.826h2.667V8.004H8.668zm41.334 13.333a2.667 2.667 0 1 1-5.334 0 2.667 2.667 0 0 1 5.334 0zm2.666 0a5.333 5.333 0 1 1-10.666 0 5.333 5.333 0 0 1 10.666 0z"
                      fill="#364B69"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M40.792 29.11a4 4 0 0 1 2.76-1.106h5.443c1.952 0 3.77.664 5.17 1.987 1.346 1.272 2.047 2.902 2.334 4.448.45 2.429-.016 5.084-1.164 7.437V52.67a3.334 3.334 0 0 1-6.621.548l-.712-4.272-.712 4.272a3.333 3.333 0 0 1-6.622-.548V40.128a4 4 0 0 1-2 .536h-6.802a4 4 0 1 1 0-8h5.2l3.726-3.555v.002zm2.543 15.527v8.034a.666.666 0 0 0 1.324.109l1.39-8.341a1.333 1.333 0 0 1 1.315-1.115h1.275a1.333 1.333 0 0 1 1.315 1.115l1.39 8.34a.666.666 0 0 0 1.324-.108V41.559c0-.214.052-.424.15-.614 1.03-1.986 1.404-4.164 1.06-6.02-.21-1.128-.699-2.197-1.544-2.996-.863-.814-2.007-1.258-3.339-1.258h-5.441c-.343 0-.674.132-.922.368L38.52 34.96c-.247.237-.577.37-.92.37h-5.734a1.333 1.333 0 1 0 0 2.666h6.802c.343 0 .673-.132.92-.37l1.494-1.423a1.333 1.333 0 0 1 2.253.965v7.47-.002z"
                      fill="#364B69"
                    />
                  </svg>

                  <span>All</span>
                </button>
                <button
                  class="flex flex-col items-center h-24 px-5 text-gray-dark transition-colors duration-150 bg-white rounded-lg ring-1 ring-gray-300 focus:outline-none text-xs"
                  @click="typeSelected = 1"
                  :class="{
                    'bg-green-light text-yellow-100': typeSelected == 1,
                  }"
                >
                  <svg
                    width="50"
                    height="65"
                    viewBox="0 0 65 65"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#qqf9279wva)">
                      <path
                        d="M5.873 21.956a3.1 3.1 0 0 1-.058-.067l.013.003-.104-.119a3.428 3.428 0 0 0-.161-.177 5.04 5.04 0 0 0-1.98-1.224l-2.45-.8a.971.971 0 0 1-.468-1.47.975.975 0 0 1 .468-.353l2.45-.8a5.053 5.053 0 0 0 1.949-1.226c.116-.134.225-.272.327-.415.364-.447.652-.95.853-1.49l.816-2.509A.972.972 0 0 1 9 10.841c.048.04.093.086.133.134.094.094.167.21.214.333l.801 2.447a5.057 5.057 0 0 0 3.196 3.194l2.45.8.05.011a.97.97 0 0 1 .468 1.47.96.96 0 0 1-.47.353l-2.45.8c-.744.249-1.42.669-1.973 1.225a5.054 5.054 0 0 0-1.223 1.973l-.8 2.448-.023.06a.959.959 0 0 1-.222.275.38.38 0 0 0-.043.057.259.259 0 0 1-.067.076.973.973 0 0 1-1.33-.208.95.95 0 0 1-.14-.266l-.8-2.447a5.056 5.056 0 0 0-.8-1.507 1.626 1.626 0 0 0-.099-.113h.001zm32.268-.944a7.997 7.997 0 0 1-5.657 13.655 8.003 8.003 0 0 1-7.391-11.06 7.998 7.998 0 0 1 7.391-4.938c2.123 0 4.157.843 5.659 2.343h-.002zm-8.957 2.357a4.666 4.666 0 1 0 6.6 6.6 4.666 4.666 0 0 0-6.6-6.6zm24.97-12.698H11.942l.734 2.25c.116.352.313.671.573.934.034.032.07.061.11.088.029.02.057.04.082.064h40.715a1.667 1.667 0 0 1 1.666 1.666v32.662A1.667 1.667 0 0 1 54.155 50H45.82v-8.334a4.333 4.333 0 0 0-4.333-4.334H23.481a4.333 4.333 0 0 0-4.333 4.334v8.33h-8.333a1.666 1.666 0 0 1-1.668-1.666V29.269a3.58 3.58 0 0 1-.667.071 3.613 3.613 0 0 1-2.099-.667c-.21-.162-.4-.347-.568-.552v20.212a4.998 4.998 0 0 0 5 5h43.342a4.999 4.999 0 0 0 5-5.002V15.669a4.997 4.997 0 0 0-5-4.998zM22.484 49.997v-8.33a1 1 0 0 1 1-1h18.002a1 1 0 0 1 1 1v8.33H22.483zm-8.195-20.996a2.952 2.952 0 0 0 1.84-1.862l.465-1.427a.563.563 0 0 1 .858-.268.557.557 0 0 1 .206.267l.464 1.428A2.934 2.934 0 0 0 19.988 29l1.427.464.029.008a.562.562 0 0 1 .37.532.563.563 0 0 1-.37.531l-1.43.465a2.944 2.944 0 0 0-1.867 1.863l-.467 1.427a.563.563 0 0 1-.856.266.555.555 0 0 1-.207-.266l-.464-1.427a2.932 2.932 0 0 0-1.866-1.87l-1.427-.465a.567.567 0 0 1-.275-.859.559.559 0 0 1 .274-.205l1.429-.464z"
                        fill="#364B69"
                      />
                    </g>
                    <defs>
                      <clipPath id="qqf9279wva">
                        <path
                          fill="#fff"
                          transform="translate(.488 .004)"
                          d="M0 0h64v64H0z"
                        />
                      </clipPath>
                    </defs>
                  </svg>

                  <span>Classes</span>
                </button>
                <button
                  class="flex flex-col items-center h-24 px-5 text-gray-dark transition-colors duration-150 bg-white rounded-lg ring-1 ring-gray-300 focus:outline-none text-xs"
                  @click="typeSelected = 2"
                  :class="{
                    'bg-green-light text-yellow-100': typeSelected == 2,
                  }"
                >
                  <svg
                    width="50"
                    height="65"
                    viewBox="0 0 65 65"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M36.3058 30.6706C36.3058 31.7314 35.8844 32.7489 35.1343 33.499C34.3841 34.2491 33.3667 34.6706 32.3058 34.6706C31.245 34.6706 30.2275 34.2491 29.4774 33.499C28.7273 32.7489 28.3058 31.7314 28.3058 30.6706C28.3058 29.6097 28.7273 28.5923 29.4774 27.8421C30.2275 27.092 31.245 26.6706 32.3058 26.6706C33.3667 26.6706 34.3841 27.092 35.1343 27.8421C35.8844 28.5923 36.3058 29.6097 36.3058 30.6706ZM18.9725 37.3372C19.4978 37.3372 20.0179 37.2338 20.5032 37.0328C20.9885 36.8317 21.4295 36.5371 21.8009 36.1657C22.1724 35.7942 22.467 35.3533 22.668 34.868C22.869 34.3827 22.9725 33.8625 22.9725 33.3372C22.9725 32.812 22.869 32.2918 22.668 31.8065C22.467 31.3212 22.1724 30.8802 21.8009 30.5088C21.4295 30.1374 20.9885 29.8427 20.5032 29.6417C20.0179 29.4407 19.4978 29.3372 18.9725 29.3372C17.9116 29.3372 16.8942 29.7587 16.1441 30.5088C15.3939 31.259 14.9725 32.2764 14.9725 33.3372C14.9725 34.3981 15.3939 35.4155 16.1441 36.1657C16.8942 36.9158 17.9116 37.3372 18.9725 37.3372V37.3372ZM45.6392 37.3372C46.1644 37.3372 46.6846 37.2338 47.1699 37.0328C47.6552 36.8317 48.0961 36.5371 48.4676 36.1657C48.839 35.7942 49.1337 35.3533 49.3347 34.868C49.5357 34.3827 49.6392 33.8625 49.6392 33.3372C49.6392 32.812 49.5357 32.2918 49.3347 31.8065C49.1337 31.3212 48.839 30.8802 48.4676 30.5088C48.0961 30.1374 47.6552 29.8427 47.1699 29.6417C46.6846 29.4407 46.1644 29.3372 45.6392 29.3372C44.5783 29.3372 43.5609 29.7587 42.8107 30.5088C42.0606 31.259 41.6392 32.2764 41.6392 33.3372C41.6392 34.3981 42.0606 35.4155 42.8107 36.1657C43.5609 36.9158 44.5783 37.3372 45.6392 37.3372V37.3372ZM5.63916 16.8466C5.63916 13.0039 9.15383 10.2012 12.8178 10.7132C17.0205 11.3079 23.7965 12.0039 32.3058 12.0039C40.8152 12.0039 47.5912 11.3052 51.7938 10.7159C55.4578 10.2012 58.9725 13.0039 58.9725 16.8466V47.1639C58.9725 51.0039 55.4578 53.8039 51.7992 53.2919C45.3386 52.4161 38.8255 51.9857 32.3058 52.0039C23.7992 52.0039 17.0205 52.7026 12.8152 53.2919C9.15383 53.8039 5.64183 51.0039 5.63916 47.1612V16.8466ZM12.2605 14.6759C10.8632 14.4812 9.63916 15.5772 9.63916 16.8466V47.1639C9.63916 48.4306 10.8605 49.5266 12.2605 49.3292C12.6952 49.2706 13.1538 49.2066 13.6392 49.1452V42.6706C13.6392 41.9633 13.9201 41.2851 14.4202 40.785C14.9203 40.2849 15.5986 40.0039 16.3058 40.0039H22.9725V48.2812C24.2445 48.2039 25.5778 48.1399 26.9725 48.0946V40.0039C26.9725 39.2967 27.2534 38.6184 27.7535 38.1183C28.2536 37.6182 28.9319 37.3372 29.6392 37.3372H34.9725C35.6797 37.3372 36.358 37.6182 36.8581 38.1183C37.3582 38.6184 37.6392 39.2967 37.6392 40.0039V48.0919C39.0338 48.1399 40.3672 48.2039 41.6392 48.2786V40.0039H48.3058C49.0131 40.0039 49.6913 40.2849 50.1914 40.785C50.6915 41.2851 50.9725 41.9633 50.9725 42.6706V49.1452C51.4578 49.2066 51.9192 49.2706 52.3512 49.3319C53.7512 49.5266 54.9725 48.4306 54.9725 47.1612V16.8466C54.9725 15.5772 53.7485 14.4812 52.3512 14.6759C47.9965 15.2892 41.0312 16.0039 32.3058 16.0039C23.5805 16.0039 16.6152 15.2866 12.2605 14.6759V14.6759Z"
                      fill="#364B69"
                    />
                  </svg>
                  <span>Class Packs</span>
                </button>
                <!-- <button
                  class="flex flex-col items-center h-24 text-gray-dark transition-colors duration-150 bg-white rounded-lg ring-1 ring-gray-300 focus:outline-none text-xs"
                  @click="typeSelected = 3"
                  :class="{
                    'bg-green-light text-yellow-100': typeSelected == 3,
                  }"
                >
                  <svg
                    width="50"
                    height="65"
                    viewBox="0 0 65 65"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M22.525 36.01V21.623a2.4 2.4 0 0 1 3.748-1.984l11.552 7.84a1.6 1.6 0 0 1 .003 2.65l-11.552 7.865a2.4 2.4 0 0 1-3.75-1.984zm-16-18.406a8 8 0 0 1 8-8h28.8a8 8 0 0 1 8 8v22.4a8 8 0 0 1-8 8h-28.8a8 8 0 0 1-8-8v-22.4zm8-4.8a4.8 4.8 0 0 0-4.8 4.8v22.4a4.8 4.8 0 0 0 4.8 4.8h28.8a4.8 4.8 0 0 0 4.8-4.8v-22.4a4.8 4.8 0 0 0-4.8-4.8h-28.8zm0 38.4a7.988 7.988 0 0 0 6.4 3.2h24a12.8 12.8 0 0 0 12.8-12.8v-17.6a7.988 7.988 0 0 0-3.2-6.4v24a9.6 9.6 0 0 1-9.6 9.6h-30.4z"
                      fill="#364B69"
                    />
                  </svg>

                  <span>On Demand</span>
                </button> -->
              </div>
            </div>
            <hr class="text-gray-400 py-2" />
            <div class="flex items-center justify-between">
              <button
                type="button"
                class="h-10 px-4 text-sm text-gray-dark transition-colors duration-150 rounded-lg focus:outline-none hover:shadow-lg"
                @click="onclickClear"
              >
                Clear All
              </button>
              <button
                type="button"
                class="h-10 px-4 text-sm text-white transition-colors duration-150 bg-green-light rounded-lg focus:outline-none hover:shadow-lg"
                @click="applyAllFilters"
              >
                Apply Filter(s)
              </button>
            </div>
          </Modal>
        </div>
      </div>
    </div>
  </UserLayout>
</template>

<script>
// import SideBarFilter from "@/components/SideBarFilter.vue";
//import SessionCard from "@/components/SessionCard";
import Card from "@/components/card/Card";
import UserLayout from "@/components/layouts/UserLayout";
import ContentLoader from "@/components/vue-spinner/ContentLoader";
import {
  Carousel,
  // FilterChip,
  Modal,
  Pagination,
} from "@/components/t-components";
import { FilterIcon, Plus, X } from "@/components/icons";
import MultiRangeSlider from "multi-range-slider-vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "SessionsList",
  components: {
    // SideBarFilter,
    //SessionCard,
    UserLayout,
    ContentLoader,
    Carousel,
    // FilterChip,
    Pagination,
    Modal,
    FilterIcon,
    Plus,
    X,
    MultiRangeSlider,
    Card,
  },
  data() {
    return {
      findSessionsListData: [],
      currentPage: 1,
      totalPages: "",
      isMenuOpen: false,
      languages: [],
      // categories: [],
      difficulties: [],
      defaultFilterByValues: {
        category: { label: "All", value: "all" },
        cost: { label: "All", value: "all", id: "all" },
        difficulty: { label: "All", value: "all" },
        language: { label: "All", value: "all" },
        entity_type: { label: "Sessions Only", value: 1 },
      },
      newFilterByValues: {
        category: { label: "All", value: "all" },
        cost: { label: "All", value: "all", id: "all" },
        difficulty: { name: "All", value: "all" },
        language: { label: "All", value: "all" },
        entity_type: { label: "Sessions Only", value: 1 },
      },
      filterValues: {},
      filterChipValues: [],
      searchValue: "",
      filterApplied: false,
      empty_string: "",
      CATEGORY: "category",
      allFilters: [],
      LOADING: true,
      categorySelected: "Yoga",
      languageSelected: "English",
      difficultySelected: [],
      typeSelected: "",
      filterVal: [],
      budget: 2,
      budgetMinValue: 0,
      budgetMaxValue: 50,
      selectedCategories: [],
      selectedLanguages: [],
      showMoreCategory: false,
      topSessionListLoader: true,
      categorySessionListLoader: true,
      langSessionListLoader: true
    };
  },
  // watch: {
  //   newFilterByValues: function () {
  //     this.setFilterChipValues();
  //   },
  // },
  computed: {
    ...mapGetters([
      "findSessionsList",
      "categoriesList",
      "languagesList",
      "difficultiesList",
      "filterCategoriesList",
      "topSessionList",
      "categorySessionList",
      "languageSessionList",
    ]),

    loadingStatus() {
      return this.$store.getters.loadingStatus;
    },
  },
  methods: {
    ...mapActions([
      "getFindSessionsList",
      "getFilterCategoriesList", // to do
      "getDifficultiesList",
      "getCategoriesList",
      "getLanguagesList",
      "postTopSessionList",
      "postCategorySessionList",
      "postLanguageSessionList",
    ]),

    imgLoadHandler() {
      this.LOADING = false;
    },

    async handlePageChange(page) {
      this.currentPage = page;
      const query = {
        page,
      };
      const payload = { ...this.filterValues, q: this.searchValue };
      this.findSessionsListData = [];
      await this.getFindSessionsList({ query, payload });
      this.findSessionsListData = this.findSessionsList.data.data || [];
    },

    handleClickMenu() {
      this.isMenuOpen = !this.isMenuOpen;
      this.showMoreCategory = false;
    },

    // type
    async handleFilterChange(key, option) {
      let payload = {};
      if (key === "cost") {
        if (option.value === "all") {
          payload = {
            ...this.filterValues,
            cost_min: "",
            cost_max: "",
            q: this.searchValue,
          };
        } else {
          payload = {
            ...this.filterValues,
            ...option.value,
            q: this.searchValue,
          };
        }
      } else {
        if (option.value === "all") {
          payload = {
            ...this.filterValues,
            [key]: "",
            q: this.searchValue,
          };
        } else {
          payload = {
            ...this.filterValues,
            [key]: option,
            q: this.searchValue,
          };
        }
      }

      const query = {
        page: 1,
      };
      this.currentPage = 1;
      this.findSessionsListData = [];
      await this.getFindSessionsList({ query, payload }).then(() => {
        this.filterApplied = true;
      })
      this.findSessionsListData =
        (this.findSessionsList &&
          this.findSessionsList.data &&
          this.findSessionsList.data.data) ||
        [];
      this.totalPages =
        this.findSessionsList &&
        this.findSessionsList.data &&
        this.findSessionsList.data.last_page;
      this.filterValues = { ...this.filterValues, ...payload };
      this.newFilterByValues = { ...this.newFilterByValues, [key]: option };
    },

    async applyAllFilters() {
      this.handleClickMenu();
      var category = [];
      var language = [];
      var difficulty = [];
      const query = { page: 1 };
      this.currentPage = 1;
      this.filterApplied = true;
      this.selectedCategories &&
        this.selectedCategories.forEach((el) => {
          category.push(el.id);
        });

      this.selectedLanguages &&
        this.selectedLanguages.forEach((el) => {
          language.push(el.id);
        });

      this.difficultySelected &&
        this.difficultySelected.forEach((el) => {
          difficulty.push(el.id);
        });

      const payload = {
        cost_min: this.budgetMinValue,
        cost_max: this.budgetMaxValue,
        category: category && category.toString(),
        difficulty: difficulty && difficulty.toString(),
        language: language && language.toString(),
        type: this.typeSelected,
        q: this.searchValue
      };

      await this.getFindSessionsList({ query, payload });
      this.findSessionsListData =
        (this.findSessionsList &&
          this.findSessionsList.data &&
          this.findSessionsList.data.data) ||
        [];
      this.totalPages =
        this.findSessionsList &&
        this.findSessionsList.data &&
        this.findSessionsList.data.last_page;
    },

    async onclickClear() {
      (this.budgetMinValue = 0),
        (this.budgetMaxValue = 0),
        (this.typeSelected = "");
      (this.selectedCategories = []),
        await this.getCategoriesList(),
        (this.selectedLanguages = []),
        await this.getLanguagesList(),
        (this.difficultySelected = []),
        await this.getDifficultiesList();
      // (this.allFilters = []);
      // this.handleResetFilterValues();
    },

    // async handleResetFilterValues() {
    //   (this.newFilterByValues = {
    //     ...this.defaultFilterByValues,
    //   }),
    //     (this.filterChipValues = []);

    //   const query = {
    //     page: 1,
    //   };
    //   const payload = { q: this.searchValue };
    //   this.currentPage = 1;

    // resetAllFilters() {
    //   (this.typeSelected = ""), (this.allFilters = []);
    //   this.selectedCategories.forEach((element) => {
    //     this.categoriesList.push(element);
    //   });
    //   this.selectedCategories.length = 0;

    //   this.selectedLanguages.forEach((element) => {
    //     this.languagesList.push(element);
    //   });
    //   this.selectedLanguages.length = 0;
    //   this.handleResetFilterValues();
    // },

    // async handleClearFilterValue(key, option, type) {
    //   if (type === "multiple") {
    //     this.newFilterByValues = {
    //       ...this.newFilterByValues,
    //       [key]: {
    //         ...this.newFilterByValues[key],
    //         [option]: false,
    //       },
    //     };
    //   } else {
    //     let payload = {};
    //     if (key === "cost") {
    //       payload = {
    //         ...this.filterValues,
    //         cost_min: "",
    //         cost_max: "",
    //         q: this.searchValue,
    //       };
    //     } else {
    //       payload = { ...this.filterValues, [key]: "", q: this.searchValue };
    //     }
    //     const query = {
    //       page: 1,
    //     };
    //     this.currentPage = 1;

    //     this.findSessionsListData = [];
    //     await this.getFindSessionsList({ query, payload });
    //     this.findSessionsListData = this.findSessionsList.data.data || [];
    //     this.totalPages = this.findSessionsList.data.last_page;
    //     this.filterValues = { ...this.filterValues, ...payload };
    //     this.newFilterByValues = {
    //       ...this.newFilterByValues,
    //       [key]: this.defaultFilterByValues[key],
    //     };
    //   }
    // },

    // setFilterChipValues() {
    //   const tempArr = [];
    //   Object.keys(this.newFilterByValues).map((e) => {
    //     if (this.newFilterByValues[e] != "") {
    //       if (
    //         this.newFilterByValues[e].value !=
    //           this.defaultFilterByValues[e].value &&
    //         !this.newFilterByValues[e].current_page
    //       ) {
    //         tempArr.push({
    //           key: e,
    //           option: this.newFilterByValues[e].label,
    //           value: this.newFilterByValues[e].value, // added category id
    //           type: "single",
    //         });
    //       }
    //       if (
    //         this.newFilterByValues[e].current_page &&
    //         this.newFilterByValues[e].value !=
    //           this.defaultFilterByValues[e].value
    //       ) {
    //         tempArr.push({
    //           key: e,
    //           option: "Top Sessions",
    //           value: this.newFilterByValues[e].value, // added category id
    //           type: "single",
    //         });
    //       }
    //     }
    //   });

    //   this.filterChipValues = tempArr;
    // },

    // categoryBannerUrl(id) {
    //   var banner_url;
    //   this.categories.map((c) => {
    //     if (c.value == id) {
    //       banner_url = c.banner_url;
    //     }
    //   });
    //   return banner_url;
    // },

    UpdateValues(e) {
      this.budgetMinValue = e.minValue;
      this.budgetMaxValue = e.maxValue;
    },

    onclickCategory(cat) {
      var index = this.selectedCategories.findIndex((el) => el.id == cat.id);
      if (index === -1) {
        this.selectedCategories.push(cat);
        this.categoriesList.splice(
          this.categoriesList.findIndex((item) => item.id === cat.id),
          1
        );
      } else {
        this.selectedCategories.splice(
          this.selectedCategories.findIndex((item) => item.id === cat.id),
          1
        );
        this.categoriesList.push(cat);
      }
    },

    onclickDifficulty(dif) {
      var index = this.difficultySelected.findIndex((el) => el.id == dif.id);
      if (index === -1) {
        this.difficultySelected.push(dif);
        this.difficultiesList.splice(
          this.difficultiesList.findIndex((item) => item.id === dif.id),
          1
        );
      } else {
        this.difficultySelected.splice(
          this.difficultySelected.findIndex((item) => item.id === dif.id),
          1
        );
        this.difficultiesList.push(dif);
      }
    },

    onclickLanguage(lang) {
      var index = this.selectedLanguages.findIndex((el) => el.id == lang.id);
      if (index === -1) {
        this.selectedLanguages.push(lang);
        this.languagesList.splice(
          this.languagesList.findIndex((item) => item.id === lang.id),
          1
        );
      } else {
        this.selectedLanguages.splice(
          this.selectedLanguages.findIndex((item) => item.id === lang.id),
          1
        );
        this.languagesList.push(lang);
      }
      this.assignSearchCategory(filter);
    },
  },
  async created() {
    const query = {
      page: this.currentPage,
    };
    // type,
    const { filter } = this.$route.query;
    
    if (filter) {
      this.filterApplied = true;
      var val = this.assignSearchCategory(filter);
      const payload = {
        cost_min: this.budgetMinValue,
        cost_max: this.budgetMaxValue,
        category: val,
        difficulty: null,
        language: "",
        type: this.typeSelected,
        q: filter
      };
      await this.getFindSessionsList({ query, payload });
      this.findSessionsListData =
        (this.findSessionsList &&
          this.findSessionsList.data &&
          this.findSessionsList.data.data) ||
        [];
      this.totalPages =
        this.findSessionsList &&
        this.findSessionsList.data &&
        this.findSessionsList.data.last_page;
      this.searchValue = filter;
    } else {
      // await this.getFindSessionsList({ query });
    }
    //Code to show filter if coming from home page Topcategories Section to find session
    if (this.$route.query.category) {
      this.searchValue = "";
      const options = {
        value: this.$route.query.category,
        label: this.$route.query.category_name,
      };
      this.handleFilterChange("category", options, "button");
    }
    //Added if condition here to avoid error if nothing is found when coming from topCategories to find session
    if (this.findSessionsList.data != null) {
      this.findSessionsListData = this.findSessionsList.data.data || [];
      this.totalPages = this.findSessionsList.data.last_page;
    }

    // await this.getFilterCategoriesList();
    // const categories =
    //   this.filterCategoriesList &&
    //   this.filterCategoriesList.category.map((item) => {
    //     return {
    //       label: item.name,
    //       value: item.id,
    //       banner_url: item.banner_url,
    //     };
    //   });
    // this.categories = categories;
    await this.getCategoriesList();
    await this.getLanguagesList();
    const languages = this.languagesList.map((item) => {
      return { label: item.language, value: item.id };
    });
    this.languages = languages;
    await this.getDifficultiesList();
    const difficulties = this.difficultiesList.map((item) => {
      return { label: item.level, value: item.id };
    });

    this.difficulties = difficulties;
    await this.$store.dispatch('postTopSessionList').then(() => {
      this.topSessionListLoader = false
    }).catch(() => {
      this.topSessionListLoader = false
    })
    this.$store.dispatch('postCategorySessionList', { category: 1 }).then(() => {
      this.categorySessionListLoader = false
    }).catch(() => {
      this.categorySessionListLoader = false
    })
    this.$store.dispatch('postLanguageSessionList', { language: 1 }).then(() => {
      this.langSessionListLoader = false
    }).catch(() => {
      this.langSessionListLoader = false
    })
  },
};
</script>

<style>
.multi-range-slider {
  border: none;
  box-shadow: none;
  padding: 14px 14px;
}
.multi-range-slider .bar-left {
  box-shadow: none;
  -webkit-box-shadow: none;
  border: solid 0px #8dc73f;
}
.multi-range-slider .bar-left::after {
  background-color: #8dc73f;
}
.multi-range-slider .bar-inner {
  box-shadow: none;
  -webkit-box-shadow: none;
  border: solid 1px #8dc73f;
  background-color: #8dc73f;
}
.multi-range-slider .bar-right {
  box-shadow: none;
  -webkit-box-shadow: none;
  border: solid 0px #8dc73f;
}
.multi-range-slider .thumb::before {
  box-shadow: none;
  -webkit-box-shadow: none;
  border: solid 1px #8dc73f;
  background-color: #8dc73f;
}
.multi-range-slider .thumb .caption * {
  background-color: #8dc73f;
}
</style>

<style scoped>
.height-27 {
  height: 27rem;
}

::-webkit-scrollbar {
  width: 2px;
}
::-webkit-scrollbar-thumb {
  background: #707070;
  border-radius: 6px;
}
</style>
